import { render } from "./ProposalUpdate.vue?vue&type=template&id=85638824&scoped=true"
import script from "./ProposalUpdate.vue?vue&type=script&lang=js"
export * from "./ProposalUpdate.vue?vue&type=script&lang=js"

import "./ProposalUpdate.vue?vue&type=style&index=0&id=85638824&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85638824"]])

export default __exports__